import React, { ButtonHTMLAttributes } from 'react';
import cn from 'classnames';
import styles from './Login.module.scss';

export const LastUsedTag = () => (
  <div className={styles.lastLoginMethodTag}>
    <svg width="6" height="15" viewBox="0 0 6 15">
      <path
        strokeWidth="0.5"
        d="M5 14.8c0-1.52-1.06-3.3-3.13-5.36a2.87 2.87 0 0 1-.92-1.75 2.1 2.1 0 0 1 .6-1.71c2.3-2.2 3.45-4.08 3.45-5.68v-1h1v16h-1Z"
      />
    </svg>
    <div className={styles.bg}>Last used</div>
  </div>
);

export function LoginButton({
  children,
  onClick,
  disabled,
  className,
  showLastUsedTag,
}: { showLastUsedTag?: boolean } & ButtonHTMLAttributes<{}>) {
  return (
    <div className={styles.loginBtnContainer}>
      <button
        type="button"
        className={cn(styles.loginBtn, className)}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
      {showLastUsedTag && <LastUsedTag />}
    </div>
  );
}
